import { Box, Icon } from '@hover/blueprint';
import { iX } from '@hover/icons';
import React from 'react';
import ReactDOM from 'react-dom';

import { DownloadImage } from 'src/modules/renderings/components/RenderingsHub/DownloadImage';
import { useRenderingContext } from 'src/modules/renderings/hooks';
import { useFocusedView } from 'src/modules/renderings/hooks/useFocusedView';
import { useHeaderPortal } from 'src/modules/renderings/hooks/useHeaderPortal';
import { useIsMobileSize } from 'src/modules/renderings/hooks/useIsMobileSize';
import { Button } from 'src/shared/components';

const HeaderControls = ({
  shareButton,
  imageUrl,
}: {
  shareButton: JSX.Element;
  imageUrl: string;
}) => {
  const { ref } = useHeaderPortal();
  const { trackingData } = useRenderingContext();
  const { isFocusedView, toggleFocusedView } = useFocusedView();
  const isMobileSize = useIsMobileSize();
  if (!ref.current || !isFocusedView) {
    return null;
  }

  return ReactDOM.createPortal(
    <Box>
      <DownloadImage
        color="neutral50"
        iconOnly={isMobileSize}
        imageUrl={imageUrl}
        translationKey="renderings.download"
      />
      {shareButton}
      <Button
        fill="minimal"
        label="full-screen-icon"
        onClick={toggleFocusedView}
        optionalTrackingProperties={{ ...trackingData }}
        shape="square"
        sx={{ color: 'neutral50' }}
      >
        <Icon icon={iX} />
      </Button>
    </Box>,
    ref.current,
  );
};

export { HeaderControls };
